"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogLevels = exports.LogTypes = exports.PeerEvents = exports.CustomEvents = exports.HOST_IP = void 0;
exports.HOST_IP = "host:ip";
var CustomEvents;
(function (CustomEvents) {
    CustomEvents["peersChange"] = "peersChange";
    CustomEvents["debugger"] = "debugger";
})(CustomEvents = exports.CustomEvents || (exports.CustomEvents = {}));
var PeerEvents;
(function (PeerEvents) {
    PeerEvents["signal"] = "signal";
    PeerEvents["connect"] = "connect";
    PeerEvents["data"] = "data";
    PeerEvents["error"] = "error";
    PeerEvents["close"] = "close";
})(PeerEvents = exports.PeerEvents || (exports.PeerEvents = {}));
var LogTypes;
(function (LogTypes) {
    LogTypes["graphqlError"] = "graphqlError";
    LogTypes["networkError"] = "networkError";
    LogTypes["signalReceived"] = "signalReceived";
    LogTypes["signalReceivedError"] = "signalReceivedError";
    LogTypes["signalSent"] = "signalSent";
    LogTypes["signalSentError"] = "signalSentError";
    LogTypes["metricSent"] = "metricSent";
    LogTypes["metricSentError"] = "metricSentError";
    LogTypes["signalAnswer"] = "signalAnswer";
    LogTypes["signalOffer"] = "signalOffer";
    LogTypes["signalOfferError"] = "signalOfferError";
    LogTypes["subscriptionError"] = "subscriptionError";
    LogTypes["sendError"] = "sendError";
    LogTypes["wsConnected"] = "wsConnected";
    LogTypes["wsDisconnected"] = "wsDisconnected";
    LogTypes["wsReconnecting"] = "wsReconnecting";
    LogTypes["wsReconnected"] = "wsReconnected";
    LogTypes["wsError"] = "wsError";
    LogTypes["wsClientError"] = "wsClientError";
    LogTypes["onPeerSignal"] = "onPeerSignal";
    LogTypes["onPeerConnect"] = "onPeerConnect";
    LogTypes["onPeerMessage"] = "onPeerMessage";
    LogTypes["onPeerError"] = "onPeerError";
    LogTypes["onPeerClose"] = "onPeerClose";
    LogTypes["peerDestroyError"] = "peerDestroyError";
})(LogTypes = exports.LogTypes || (exports.LogTypes = {}));
var LogLevels;
(function (LogLevels) {
    LogLevels["error"] = "error";
    LogLevels["warn"] = "warn";
    LogLevels["info"] = "info";
    LogLevels["debug"] = "debug";
})(LogLevels = exports.LogLevels || (exports.LogLevels = {}));
//# sourceMappingURL=types.js.map